<template>
    <div class="ui segment">
        <FeedbackBox :message="myMessage" :correct="isSuccess" :incorrect="isError" />
        <a class="ui button" :href="'/register/'+registrationkey" v-if="registrationkey && !isSuccess">Go Back</a>
    </div>
</template>
<script>
import FeedbackBox from './FeedbackBox.vue'
export default {
    name: 'EnrollmentResult',
    components: { FeedbackBox },
    props: ['success', 'error', 'message', 'registrationkey'],
    data() {
        return {
            isSuccess: false,
            isError: false,
            myMessage: ''
        }
    },
    mounted() {
        if (!this.success && !this.error && !this.message) {
            this.myMessage = "Something went wrong."
            this.isError = true
        }
        else {
            this.isSuccess = this.success
            this.isError = this.error
            this.myMessage = this.message
        }
    }
}
</script>
<style scoped>
.ui.segment {
    max-width: 640px;
    margin: 0 auto;
    text-align: left;
}
.button {
    margin-top: 15px;
}
</style>